module.exports = __webpack_public_path__ + "img/info-circle-solid.827f6749.svg";